import { render, staticRenderFns } from "./JobPeoplePage.vue?vue&type=template&id=1b4da03c&"
import script from "./JobPeoplePage.vue?vue&type=script&lang=js&"
export * from "./JobPeoplePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports